import { durationForInboundAddon } from '@/shared/constants/other.constants'
import { useFeaturesStore } from '@/shared/store/feature'
import { VisitorType } from '@/shared/types/store.types'
import { checkAgeForInboundAddon } from '@/shared/utils'

export const usePrepareInboundAddon = () => {
  const { isInboundAddonEnabled, isInboundDefaultStateAgeLogicEnabled } = useFeaturesStore()
  const checkPrepareInboundAddon = (holder: VisitorType, entryValue: string) => {
    const validEntry = durationForInboundAddon.includes(entryValue)
    const validAge = holder.birthDate && checkAgeForInboundAddon(holder.birthDate)
    return (
      isInboundAddonEnabled &&
      validEntry &&
      validAge &&
      holder.country?.length &&
      holder.nationality?.length
    )
  }
  return {
    checkPrepareInboundAddon,
    isInboundAddonEnabled,
    isInboundDefaultStateAgeLogicEnabled,
  }
}
